'use strict';

var NavigationHistoryController = function NavigationHistoryController($scope, $state, navigationHistoryService, momentService) {
  $scope.selectedHistoryItem = null;
  $scope.getHistoryList = navigationHistoryService.getHistory;
  $scope.changeHistoryItem = function () {
    var item = $scope.selectedHistoryItem;
    $state.go('app.' + item.state.screen, {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: item.state.searchCriteria
      }
    });
    $scope.selectedHistoryItem = null;
  };
  $scope.$on('$stateChangeSuccess', function (event, toState) {
    if (toState) {
      navigationHistoryService.saveState({
        screen: toState.name.replace('app.', ''),
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP)
      });
    }
  });
};
NavigationHistoryController.$inject = ['$scope', '$state', 'NavigationHistoryService', 'MomentService'];
module.exports = NavigationHistoryController;